import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TagsInput } from "react-tag-input-component";
import moment from "moment/moment";
import { createNotes } from "../services/client/addclientApi";
import axiosInstanceAuth from "../apiInstances/axiosInstanceAuth";
import { Dropdown } from "primereact/dropdown";
import { options } from "../components/Common/DropdownValue";
import ReactPaginate from "react-paginate";
import { OverlayPanel } from "primereact/overlaypanel";
import { BsPersonPlus, BsTrash, BsXLg } from "react-icons/bs";
import SearchableOptions from "../components/SearchableOptions";
import { getAdminUsers } from "../services/Adminuser";
import { Spinner } from "react-bootstrap";

const MultiPage = () => {
  const [basicList, setBasicList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState({});
  const [filter, setFilter] = useState({});
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 0,
    totalCount: 0,
    hasNextPage: false,
    hasPrevPage: false,
    limit: 10,
  });
  const [users, setUsers] = useState([]);
  const [reload, setReload] = useState(false);

  const fetchData = async () => {
    try {
      setLoading(true);
      const params = {
        page,
        limit,
        search,
        sortBy: sort.sortBy || "createdAt",
        sortOrder: sort.sortOrder || "desc",
        ...filter,
      };

      const response = await axiosInstanceAuth.get("/multi-website-user/list", {
        params,
      });
      setBasicList(response.data.data.users);
      setPagination(response.data.data.pagination);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, limit, search, sort, filter, reload]);

  // Fetch users for assignment
  useEffect(() => {
    getAdminUsers().then((res) => {
      const result = res.data.map((r) => ({
        fullName: `${r.fname} ${r.lname}`,
        fName: r.fname,
        lName: r.lname,
        email: r.email,
        role: r.role,
        _id: r._id,
      }));
      setUsers(result);
    });
  }, []);

  // Handle page change
  const handlePageChange = ({ selected }) => {
    setPage(selected + 1);
  };

  // Handle items per page change
  const handleSelectChange = (e) => {
    setLimit(parseInt(e.value));
    setPage(1); // Reset to first page when changing limit
  };

  // Handle tag changes
  const handleTagChange = async (id, newTags) => {
    const body = { tags: newTags };
    try {
      await axiosInstanceAuth.put(`/multi-website-user/tags/${id}`, body);
      //   fetchData();
      // You might want to refresh the data here
    } catch (error) {
      console.error("Error updating tags:", error);
    }
  };

  const handleDelete = async (id) => {
    await axiosInstanceAuth.delete(`/multi-website-user/delete/${id}`);
    setReload(!reload);
  };

  return (
    <div className="content-wrapper">
      <div className="container-fluid flex-grow-1 container-p-y">
        <div className="card" style={{ borderRadius: "0" }}>
          <div className="d-flex p-2">
            <input
              type="text"
              placeholder="Search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="form-control"
              style={{ width: "200px" }}
            />
          </div>

          <div className="new-table table-responsive">
            <table className="table table-hover prospect-table" width="100%">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Timestamp</th>
                  <th>Email</th>
                  <th>Tags</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="5" className="text-center">
                      <Spinner />
                    </td>
                  </tr>
                ) : (
                  basicList?.length > 0 &&
                  basicList?.map((customer, index) => (
                    <tr key={customer.id || index}>
                      <td>{index + 1}</td>
                      <td>
                        {moment(customer?.createdAt).format(
                          `DD/MM/yyyy hh:mm a`
                        )}
                      </td>
                      <td>{customer?.email}</td>
                      <td onClick={(e) => e.stopPropagation()}>
                        <div
                          style={{
                            display: "flex",
                            width: "100%",
                          }}
                        >
                          <AssignUserModel
                            setReload={() => setReload(!reload)}
                            data={customer}
                            customer={customer}
                            users={users}
                          />
                          <TagsInput
                            value={customer.tags || []}
                            onChange={(newTags) =>
                              handleTagChange(customer.id, newTags)
                            }
                            placeHolder="tags"
                            style={{
                              height: "20px",
                            }}
                          />
                        </div>
                      </td>
                      <td align="right">
                        <BsTrash
                          onClick={() => handleDelete(customer.id)}
                          fontSize={20}
                          className="cursor-pointer"
                        />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
            {!loading && (basicList?.length === 0 || !basicList) && (
              <div className="text-center py-4">
                <p>No data available</p>
              </div>
            )}
          </div>

          {/* Pagination */}
          {basicList?.length > 0 && (
            <div className="d-flex justify-content-between">
              <ReactPaginate
                pageCount={pagination?.totalPages || 0}
                pageRangeDisplayed={5}
                marginPagesDisplayed={2}
                onPageChange={handlePageChange}
                containerClassName={"pagination"}
                activeClassName={"active"}
                forcePage={(pagination?.currentPage || 1) - 1}
              />

              <div className="my-auto pl-2">
                <Dropdown
                  value={limit.toString()}
                  onChange={handleSelectChange}
                  options={options}
                  placeholder="Select an option"
                  className=""
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// AssignUserModel component
const AssignUserModel = ({ data, setReload, customer, users }) => {
  const overlayPanelRef = useRef(null);

  const handleSubmit = async (e) => {
    try {
      await axiosInstanceAuth.put(`/multi-website-user/assign/${data.id}`, {
        userId: e?._id || "",
      });
      setReload();
      overlayPanelRef.current.toggle(e);
    } catch (error) {
      console.error("Error assigning user:", error);
    }
  };

  return (
    <>
      <div
        style={{
          border: "1px solid #DBDADE",
          padding: "0 5px",
          borderRadius: "6px 0 0 6px",
          background: customer?.assignedUser ? `#0084FF52` : `#FFF`,
          display: "flex",
          alignItems: "center",
        }}
        className="assign-u"
        role="button"
        onClick={(e) => {
          e.stopPropagation();
          overlayPanelRef.current.toggle(e);
        }}
      >
        {!customer?.assignedUser && <BsPersonPlus />}
        {customer?.assignedUser &&
          `${customer?.assignedUser?.fname?.charAt(0) || ""} ${
            customer?.assignedUser?.lname?.charAt(0) || ""
          }`}
      </div>
      <OverlayPanel ref={overlayPanelRef} dismissable style={{ padding: 0 }}>
        <SearchableOptions
          value={[]}
          options={users}
          onChange={handleSubmit}
          placeholder="Select an user"
          style={{ width: "100%" }}
          optionLabel="fullName"
          optionValue="_id"
          multiple
        />

        {customer?.assignedUser && (
          <button className="btn btn-danger mb-2 mx-3" onClick={handleSubmit}>
            <BsXLg />
            &nbsp;&nbsp; Remove
          </button>
        )}
      </OverlayPanel>
    </>
  );
};

export default MultiPage;
